import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { MicrosoftTeamsDevice } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class DeviceService {
  private http = inject(HttpClient);

  getDeviceStatus(tenantId: string, id: string): Observable<MicrosoftTeamsDevice> {
    return this.http.get<MicrosoftTeamsDevice>(`/services/microsoft/macs/tenants/${tenantId}/teams-devices/${id}`);
  }
}
